import useFetch from './useFetch.ts';
import { useCallback } from 'react';
export const useLoginWithGoogleRequest = function () {
    const fetcher = useFetch();
    return useCallback(function (token) {
        return fetcher(`/api/user/login_with_google`, {
            method: 'POST',
            body: JSON.stringify({
                token,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }, [fetcher]);
};
